import InputMobile from '../form/InputMobile.js';

function PanelInputMobile(props) {
   return (
    <div className="step">
        <p>步驟1：輸入您的手提電話號碼(必填)</p>
        <InputMobile geoList={props.geoList} setGeocode={props.setGeocode} setMobile={props.setMobile} groupName="geocode1"></InputMobile>
        <p>請重覆輸入您的手提電話號碼(必填)</p>
        <InputMobile geoList={props.geoList} setGeocode={props.setRepeatGeocode} setMobile={props.setRepeatMobile} groupName="geocode2"></InputMobile>
    </div>
   );
 }
 
export default PanelInputMobile;